import React from 'react';
import InspectionQuoteLineItemDetails from './InspectionQuoteLineItemDetails';
import { Quote } from '../../../models/workItem';
import InspectionQuoteSummary from './InspectionQuoteSummary';

interface InspectionQuoteDetailsProps {
  quote: Quote;
  propertyId: string
}

const InspectionQuoteDetails: React.FC<InspectionQuoteDetailsProps> = ({ quote, propertyId }) => {
  return (
    <>
      {/* Summary Section */}
      <InspectionQuoteSummary quote={quote} />

      {/* Line Items */}
      <div className="px-6 pb-6">
        <div className="space-y-4">
          {quote.analysis.lineItems.map((lineItem, index) => (
            <InspectionQuoteLineItemDetails key={index} lineItem={lineItem} propertyId={propertyId} />
          ))}
        </div>
      </div>
    </>
  );
};

export default InspectionQuoteDetails;